import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
import { GetOne_Rotation_Data, UpdateOne_Rotation_Data } from '../Redux/Actions/Rotations_Actions';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconChevron  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;
const IconXsm      = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconCheck    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IconHistory  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IconSave     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>;
const IconAdd      = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconEdit     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconDelete   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const IconConfirm  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IconRotation = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>;

/* ─── Hover Badge Tooltip ────────────────────────────────────────────────── */
const HoverBadge = ({ labels, isDark, children }) => {
  const [hovered, setHovered] = useState(false);
  if (!labels || labels.length === 0) return <>{children}</>;
  return (
    <div style={{ position: 'relative' }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {children}
      {hovered && (
        <div style={{
          position: 'absolute', bottom: 'calc(100% + 8px)', left: 0, zIndex: 99999,
          backgroundColor: isDark ? '#1e2132' : '#1e293b',
          border: `1px solid ${isDark ? '#2a2f45' : '#334155'}`,
          borderRadius: '12px', padding: '10px 12px', minWidth: '180px', maxWidth: '280px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.35)', pointerEvents: 'none',
          animation: 'fadeInUp 0.15s ease both',
        }}>
          <div style={{ position: 'absolute', bottom: -6, left: 18, width: 10, height: 10, backgroundColor: isDark ? '#1e2132' : '#1e293b', borderRight: `1px solid ${isDark ? '#2a2f45' : '#334155'}`, borderBottom: `1px solid ${isDark ? '#2a2f45' : '#334155'}`, transform: 'rotate(45deg)' }} />
          <p style={{ margin: '0 0 8px', fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8' }}>{labels.length} selected</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            {labels.map((l, i) => (
              <span key={i} style={{ padding: '3px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 600, backgroundColor: 'rgba(37,99,235,0.2)', color: isDark ? '#93c5fd' : '#bfdbfe', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

/* ─── Table Cell Hover Badge ─────────────────────────────────────────────── */
const CellBadge = ({ text, isDark, children }) => {
  const [pos, setPos] = useState(null);
  const wrapRef = useRef(null);
  const items = text ? text.split(', ').filter(Boolean) : [];
  const showBadge = items.length > 0 && text && text !== '—';

  const handleMouseEnter = () => {
    if (!wrapRef.current || !showBadge) return;
    const rect = wrapRef.current.getBoundingClientRect();
    setPos({
      top: rect.top > 160 ? rect.top - 8 : rect.bottom + 8,
      above: rect.top > 160,
      centerX: rect.left + rect.width / 2,
    });
  };

  return (
    <>
      <div ref={wrapRef} style={{ display: 'inline-block', maxWidth: '100%' }} onMouseEnter={handleMouseEnter} onMouseLeave={() => setPos(null)}>
        {children}
      </div>
      {pos && showBadge && (
        <div style={{ position: 'fixed', top: pos.above ? pos.top - 10 : pos.top, left: pos.centerX, transform: pos.above ? 'translate(-50%, -100%)' : 'translate(-50%, 0)', zIndex: 999999, pointerEvents: 'none', animation: 'fadeInUp 0.14s ease both' }}>
          <div style={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '12px', padding: '10px 12px', minWidth: '160px', maxWidth: '300px', boxShadow: '0 16px 48px rgba(0,0,0,0.5)', whiteSpace: 'normal', position: 'relative' }}>
            {pos.above
              ? <div style={{ position: 'absolute', bottom: -6, left: '50%', transform: 'translateX(-50%) rotate(45deg)', width: 10, height: 10, backgroundColor: '#1e293b', borderRight: '1px solid #334155', borderBottom: '1px solid #334155' }} />
              : <div style={{ position: 'absolute', top: -6, left: '50%', transform: 'translateX(-50%) rotate(45deg)', width: 10, height: 10, backgroundColor: '#1e293b', borderLeft: '1px solid #334155', borderTop: '1px solid #334155' }} />
            }
            <p style={{ margin: '0 0 7px', fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#94a3b8' }}>{items.length} {items.length === 1 ? 'item' : 'items'}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
              {items.map((item, i) => (
                <span key={i} style={{ padding: '3px 9px', borderRadius: '6px', fontSize: '11px', fontWeight: 600, backgroundColor: 'rgba(99,179,237,0.18)', color: '#93c5fd', whiteSpace: 'nowrap' }}>{item.trim()}</span>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

/* ─── Multi-Select ───────────────────────────────────────────────────────── */
const MultiSelect = ({ label, options, selected, onChange, isDark, getLabel, getId }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [dropPos, setDropPos] = useState({ top: 0, left: 0, width: 0, above: false });
  const triggerRef = useRef(null);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const handleOpen = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const dropHeight = 280;
      const above = spaceBelow < dropHeight && spaceAbove > spaceBelow;
      setDropPos({ left: rect.left, width: rect.width, top: above ? rect.top - dropHeight - 4 : rect.bottom + 4, above });
    }
    setOpen(o => !o);
    setSearch('');
  };

  const filtered = options.filter((o) => getLabel(o).toLowerCase().includes(search.toLowerCase()));
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  const labels = selected.map((id) => { const o = options.find((x) => getId(x) === id); return o ? getLabel(o) : ''; }).filter(Boolean);

  return (
    <HoverBadge labels={labels} isDark={isDark}>
      <div ref={ref} style={{ position: 'relative' }}>
        <div ref={triggerRef} onClick={handleOpen}
          style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', fontSize: '13px', border: `1.5px solid ${open ? '#2563eb' : (isDark ? '#2d3248' : '#e2e8f0')}`, backgroundColor: isDark ? '#151827' : '#f8fafc', color: labels.length ? (isDark ? '#f1f5f9' : '#0f172a') : (isDark ? '#6b7280' : '#94a3b8'), fontFamily: "'DM Sans',sans-serif", cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box', userSelect: 'none', minHeight: '46px', boxShadow: open ? '0 0 0 3px rgba(37,99,235,0.12)' : 'none', transition: 'border-color 0.15s, box-shadow 0.15s' }}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, marginRight: 8, fontSize: '13px' }}>
            {labels.length ? (labels.length <= 2 ? labels.join(', ') : `${labels.slice(0, 2).join(', ')} +${labels.length - 2}`) : label}
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
            {selected.length > 0 && (
              <span onClick={(e) => { e.stopPropagation(); onChange([]); }} style={{ display: 'flex', color: isDark ? '#6b7280' : '#94a3b8', padding: 2 }}><IconXsm /></span>
            )}
            <span style={{ display: 'flex', color: isDark ? '#6b7280' : '#94a3b8', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}><IconChevron /></span>
          </span>
        </div>

        {open && (
          <div style={{ position: 'fixed', top: dropPos.top, left: dropPos.left, width: dropPos.width, zIndex: 999999, backgroundColor: isDark ? '#1e2132' : '#fff', border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`, borderRadius: '12px', overflow: 'hidden', boxShadow: isDark ? '0 16px 48px rgba(0,0,0,0.55)' : '0 8px 32px rgba(0,0,0,0.12)', animation: 'ss-open 0.14s ease both' }}>
            <div style={{ position: 'relative', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}` }}>
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: isDark ? '#6b7280' : '#94a3b8', display: 'flex', pointerEvents: 'none' }}><IconSearch /></span>
              <input autoFocus value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search…"
                style={{ width: '100%', padding: '10px 12px 10px 32px', fontSize: '13px', border: 'none', outline: 'none', backgroundColor: isDark ? '#151827' : '#f8fafc', color: isDark ? '#e5e7eb' : '#1f2937', fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box' }} />
            </div>
            <div style={{ padding: '7px 12px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#f0f0f0'}`, display: 'flex', gap: 8 }}>
              {[['Select All', () => onChange(options.map(getId)), isDark ? '#93c5fd' : '#2563eb'], ['Clear', () => onChange([]), isDark ? '#9ca3af' : '#64748b']].map(([txt, fn, col]) => (
                <button key={txt} onClick={fn} style={{ fontSize: '11px', fontWeight: 700, padding: '4px 10px', borderRadius: '6px', border: `1px solid ${isDark ? '#2d3248' : '#e2e8f0'}`, backgroundColor: 'transparent', color: col, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>{txt}</button>
              ))}
              {selected.length > 0 && <span style={{ marginLeft: 'auto', fontSize: '11px', fontWeight: 700, color: isDark ? '#4ade80' : '#16a34a', display: 'flex', alignItems: 'center' }}>{selected.length} selected</span>}
            </div>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {filtered.length === 0
                ? <div style={{ padding: '14px', fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', textAlign: 'center' }}>No results</div>
                : filtered.map((o) => {
                  const id = getId(o); const isChk = selected.includes(id);
                  return (
                    <div key={id} onClick={() => toggle(id)}
                      style={{ padding: '10px 14px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, backgroundColor: isChk ? (isDark ? 'rgba(37,99,235,0.12)' : 'rgba(37,99,235,0.06)') : 'transparent', fontFamily: "'DM Sans',sans-serif" }}
                      onMouseEnter={(e) => { if (!isChk) e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)'; }}
                      onMouseLeave={(e) => { if (!isChk) e.currentTarget.style.backgroundColor = 'transparent'; }}>
                      <div style={{ width: 16, height: 16, borderRadius: 4, flexShrink: 0, border: `1.5px solid ${isChk ? '#1d4ed8' : (isDark ? '#4b5563' : '#d1d5db')}`, backgroundColor: isChk ? '#1d4ed8' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {isChk && <span style={{ color: '#fff', display: 'flex' }}><IconCheck /></span>}
                      </div>
                      <span style={{ color: isDark ? '#e5e7eb' : '#1f2937' }}>{getLabel(o)}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </HoverBadge>
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const EditMoreRotationPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [personName, setPersonName]     = useState([]);
  const [chanelname, setChanelname]     = useState([]);
  const [projectname, setProjectname]   = useState([]);
  const [devlopername, setDevelopername] = useState([]);
  const [leadsPerTurn, setLeadsPerTurn] = useState('');
  const [checked, setChecked]           = useState(true);
  const [tableData, setTableData]       = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading]           = useState(false);

  /* ── fetch all data ── */
  useEffect(() => {
    dispatch(Get_All_Sales_Action());
    dispatch(GetAllchannalData());
    dispatch(GetallProjectsdata());
    dispatch(GetDevelopersData());
    dispatch(GetOne_Rotation_Data(id));
  }, [dispatch, id]);

  const resallsales      = useSelector((s) => s.AllSales.sales);
  const reschannel       = useSelector((s) => s.AllChannalRoot.channal);
  const resAllProjects   = useSelector((s) => s.AllProjects.Projects);
  const resAllDevelopers = useSelector((s) => s.AllDevelopers.Developers);
  const resOneRotation   = useSelector((s) => s.AllRotation.Rotation);

  const allsales      = Array.isArray(resallsales?.data)      ? resallsales.data      : [];
  const allChannel    = Array.isArray(reschannel?.data)       ? reschannel.data       : [];
  const allProjects   = Array.isArray(resAllProjects?.data)   ? resAllProjects.data   : [];
  const alldevelopers = Array.isArray(resAllDevelopers?.data) ? resAllDevelopers.data : [];

  /* ── populate table from fetched rotation ── */
  useEffect(() => {
    if (resOneRotation?.data) {
      const rotation = resOneRotation.data;
      setTableData(
        rotation.sales?.map((sale) => ({
          leadsPerTurn: sale.maxLeads || 0,
          sales:        sale.salesId?.name || 'Unknown',
          channel:      rotation.channels?.map((c) => c.name).join(', ') || '',
          project:      rotation.projects?.map((p) => p.name).join(', ') || '',
          active:       rotation.active ? 'Active' : 'Inactive',
        })) || [],
      );
    }
  }, [resOneRotation]);

  /* ── filtered projects by developer ── */
  const filteredProjects = devlopername.length > 0
    ? allProjects.filter((p) => devlopername.includes(p.developer?._id))
    : allProjects;

  const handleDeveloperChange = (ids) => {
    setDevelopername(ids);
    if (ids.length > 0) {
      const fp = allProjects.filter((p) => ids.includes(p.developer?._id));
      setProjectname(fp.map((p) => p._id));
    } else {
      setProjectname([]);
    }
  };

  /* ── add / update row ── */
  const Addtotable = () => {
    if (!leadsPerTurn || leadsPerTurn == 0) return Notify('error', 'Leads per turn cannot be empty or zero', 'error');
    const row = {
      leadsPerTurn,
      sales:    personName.map((id) => allsales.find((x) => x._id === id)?.name).join(', '),
      channel:  chanelname.map((id) => allChannel.find((x) => x._id === id)?.name).join(', '),
      project:  projectname.map((id) => allProjects.find((x) => x._id === id)?.name).join(', '),
      active:   checked ? 'Active' : 'Inactive',
    };
    if (editingIndex !== null) {
      const copy = [...tableData]; copy[editingIndex] = row; setTableData(copy); setEditingIndex(null);
      Notify('success', 'Row updated successfully', 'success');
    } else {
      setTableData([...tableData, row]);
      Notify('success', 'Row added successfully', 'success');
    }
    resetForm();
  };

  const handleUpdateRow = (index) => {
    const row = tableData[index];
    setPersonName(row.sales.split(', ').map((n) => allsales.find((x) => x.name === n)?._id).filter(Boolean));
    setChanelname(row.channel.split(', ').map((n) => allChannel.find((x) => x.name === n)?._id).filter(Boolean));
    setProjectname(row.project.split(', ').map((n) => allProjects.find((x) => x.name === n)?._id).filter(Boolean));
    setLeadsPerTurn(row.leadsPerTurn);
    setChecked(row.active === 'Active');
    setEditingIndex(index);
  };

  const handleDeleteRow = (index) => {
    setTableData(tableData.filter((_, i) => i !== index));
    Notify('success', 'Row deleted', 'success');
  };

  const resetForm = () => {
    setLeadsPerTurn(''); setPersonName([]); setChanelname([]);
    setProjectname([]); setDevelopername([]); setChecked(true); setEditingIndex(null);
  };

  /* ── save all ── */
  const saveRotation = async (e) => {
    e.preventDefault();
    if (tableData.length === 0) return Notify('error', 'No data in the table to save', 'error');
    setLoading(true);
    try {
      const uniqueSalesMap = new Map();
      tableData.forEach((row) => {
        row.sales.split(', ').forEach((salesName) => {
          const s = allsales.find((x) => x.name === salesName);
          if (s && !uniqueSalesMap.has(s._id)) {
            uniqueSalesMap.set(s._id, { salesId: s._id, maxLeads: row.leadsPerTurn, assignedLeads: 0 });
          }
        });
      });
      const uniqueChannels = [...new Set(tableData.flatMap((row) =>
        row.channel.split(', ').map((n) => allChannel.find((c) => c.name === n)?._id).filter(Boolean)
      ))];
      const uniqueProjects = [...new Set(tableData.flatMap((row) =>
        row.project.split(', ').map((n) => allProjects.find((p) => p.name === n)?._id).filter(Boolean)
      ))];

      await dispatch(UpdateOne_Rotation_Data(id, {
        sales:    Array.from(uniqueSalesMap.values()),
        channels: uniqueChannels,
        projects: uniqueProjects,
        active:   tableData.some((row) => row.active === 'Active'),
      }));
      Notify('success', 'Rotation updated successfully', 'success');
      setTimeout(() => navigate('/MoreRotation'), 1500);
    } catch {
      Notify('error', 'Failed to update rotation', 'error');
    } finally {
      setLoading(false);
    }
  };

  /* ─── shared styles ─── */
  const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#64748b', marginBottom: '8px' };
  const inputStyle = { width: '100%', padding: '11px 14px', borderRadius: '10px', fontSize: '13px', border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`, backgroundColor: isDark ? '#151827' : '#f8fafc', color: isDark ? '#f1f5f9' : '#0f172a', fontFamily: "'DM Sans',sans-serif", outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s, box-shadow 0.2s' };
  const fieldWrap  = { marginBottom: '16px' };
  const divider    = { height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '20px 0' };
  const tdBase     = { padding: '12px 16px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#f0f0f0'}` };

  const actionBtn = (color, hoverBg, onClick, children, title) => (
    <button title={title} onClick={onClick}
      style={{ padding: '7px 10px', borderRadius: '8px', border: `1px solid ${isDark ? '#2d3248' : '#e2e8f0'}`, backgroundColor: 'transparent', color, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5, fontSize: '12px', fontWeight: 600, fontFamily: "'DM Sans',sans-serif", transition: 'all 0.15s' }}
      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = hoverBg; e.currentTarget.style.borderColor = color; }}
      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; }}>
      {children}
    </button>
  );

  return (
    <>
      <style>{`
        @keyframes fadeInUp { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:none; } }
        @keyframes ss-open  { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:none; } }
      `}</style>

      <div style={{ position: 'fixed', top: '50px', left: sidebarWidth, right: 0, bottom: 0, transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)', overflowY: 'auto', overflowX: 'hidden', backgroundColor: isDark ? '#0f1117' : '#f0f2f5', fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>

        {/* ── Breadcrumb ── */}
        <div style={{ padding: '14px 28px', backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
          <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Home</Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <Link to="/MoreRotation" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Rotation</Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Edit Rotation</span>
        </div>

        {/* ── Body ── */}
        <div style={{ padding: '24px 28px 48px', display: 'flex', gap: '24px', alignItems: 'flex-start', flexWrap: 'wrap' }}>

          {/* ══ LEFT — Form Card ══ */}
          <div style={{ flex: '0 0 400px', minWidth: '300px', backgroundColor: isDark ? '#1e2132' : '#ffffff', borderRadius: '20px', padding: '28px', boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)', border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0' }}>

            {/* Card Header */}
            <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: 38, height: 38, borderRadius: '10px', background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(29,78,216,0.3)', flexShrink: 0 }}>
                <span style={{ color: '#fff', display: 'flex' }}><IconRotation /></span>
              </div>
              <div>
                <h2 style={{ fontSize: '17px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: 0, letterSpacing: '-0.3px' }}>
                  {editingIndex !== null ? 'Edit Row' : 'Add Row'}
                </h2>
                <p style={{ fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
                  {editingIndex !== null ? `Editing row #${editingIndex + 1}` : 'Fill and add to the table'}
                </p>
              </div>
            </div>

            {/* Leads per Turn */}
            <div style={fieldWrap}>
              <label style={labelStyle}>Leads per Turn</label>
              <input style={inputStyle} type="number" min="0" placeholder="e.g. 5 leads per rotation…"
                value={leadsPerTurn} onChange={(e) => setLeadsPerTurn(e.target.value)}
                onFocus={(e) => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)'; }}
                onBlur={(e) => { e.target.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.target.style.boxShadow = 'none'; }} />
              <p style={{ margin: '5px 0 0', fontSize: '11px', color: isDark ? '#4b5563' : '#94a3b8' }}>Number of leads each sales rep receives per rotation cycle</p>
            </div>

            {/* Sales */}
            <div style={fieldWrap}>
              <label style={labelStyle}>Sales Representatives</label>
              <MultiSelect label="Select sales…" options={allsales} selected={personName} onChange={setPersonName} isDark={isDark} getLabel={(o) => o.name || ''} getId={(o) => o._id} />
            </div>

            {/* Channel + Developer */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '0px' }}>
              <div>
                <label style={labelStyle}>Channel</label>
                <MultiSelect label="Channel…" options={allChannel} selected={chanelname} onChange={setChanelname} isDark={isDark} getLabel={(o) => o.name || ''} getId={(o) => o._id} />
              </div>
              <div style={fieldWrap}>
                <label style={labelStyle}>Developers</label>
                <MultiSelect label="Select developers…" options={alldevelopers} selected={devlopername} onChange={handleDeveloperChange} isDark={isDark} getLabel={(o) => o.name || ''} getId={(o) => o._id} />
              </div>
            </div>

            {/* Project */}
            <div style={{ marginBottom: '16px' }}>
              <label style={labelStyle}>Project</label>
              <MultiSelect label="Project…" options={filteredProjects} selected={projectname} onChange={setProjectname} isDark={isDark} getLabel={(o) => `${o.name}${o.developer ? ` — ${o.developer.name}` : ''}`} getId={(o) => o._id} />
            </div>

            {/* Status Toggle */}
            <div style={{ padding: '12px 14px', borderRadius: '10px', border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`, backgroundColor: isDark ? '#151827' : '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
              <div>
                <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: isDark ? '#f1f5f9' : '#0f172a' }}>Activation Status</p>
                <p style={{ margin: 0, fontSize: '11px', color: isDark ? '#6b7280' : '#94a3b8' }}>{checked ? 'Active' : 'Inactive'}</p>
              </div>
              <div onClick={() => setChecked(p => !p)} style={{ width: '46px', height: '25px', borderRadius: '13px', cursor: 'pointer', backgroundColor: checked ? '#1d4ed8' : (isDark ? '#374151' : '#d1d5db'), transition: 'background-color 0.2s', position: 'relative', flexShrink: 0 }}>
                <div style={{ position: 'absolute', top: '3px', left: checked ? '24px' : '3px', width: '19px', height: '19px', borderRadius: '50%', backgroundColor: '#fff', transition: 'left 0.2s', boxShadow: '0 1px 4px rgba(0,0,0,0.25)' }} />
              </div>
            </div>

            <div style={divider} />

            {/* Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <button onClick={Addtotable} type="button"
                style={{ width: '100%', padding: '13px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', color: '#fff', fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px', transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)', fontFamily: "'DM Sans',sans-serif" }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}>
                {editingIndex !== null ? <><IconConfirm /><span>Confirm Update</span></> : <><IconAdd /><span>Add to Table</span></>}
              </button>

              <Link to="/ManageMoreRotation" style={{ textDecoration: 'none' }}>
                <button type="button"
                  style={{ width: '100%', padding: '12px', borderRadius: '10px', border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`, backgroundColor: 'transparent', color: isDark ? '#9ca3af' : '#1d4ed8', fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', cursor: 'pointer', transition: 'all 0.2s', fontFamily: "'DM Sans',sans-serif", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px' }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#1d4ed8'; e.currentTarget.style.backgroundColor = isDark ? 'rgba(29,78,216,0.08)' : 'rgba(29,78,216,0.04)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.backgroundColor = 'transparent'; }}>
                  <IconHistory /> Manage Rotations History
                </button>
              </Link>
            </div>
          </div>

          {/* ══ RIGHT — Table ══ */}
          <div style={{ flex: 1, minWidth: '300px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

            {/* Banner */}
            <div style={{ borderRadius: '16px', overflow: 'hidden', position: 'relative', background: 'linear-gradient(135deg,#1e3a8a 0%,#1d4ed8 50%,#3b82f6 100%)', padding: '24px 28px', boxShadow: '0 8px 32px rgba(29,78,216,0.3)' }}>
              <div style={{ position: 'absolute', top: -20, right: -20, width: 110, height: 110, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.06)' }} />
              <div style={{ position: 'relative', zIndex: 1 }}>
                <h3 style={{ color: '#fff', fontSize: '18px', fontWeight: 700, margin: '0 0 4px', letterSpacing: '-0.3px' }}>Edit Distribution</h3>
                <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '13px', margin: 0 }}>Modify the rotation table, then save all changes at once.</p>
              </div>
            </div>

            {/* Table Card */}
            <div style={{ backgroundColor: isDark ? '#1e2132' : '#ffffff', borderRadius: '16px', border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0', boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.3)' : '0 2px 12px rgba(0,0,0,0.05)', overflow: 'hidden' }}>

              <div style={{ padding: '16px 20px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <p style={{ margin: 0, fontSize: '11px', fontWeight: 700, color: isDark ? '#6b7280' : '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Rotation Entries</p>
                  <p style={{ margin: 0, fontSize: '22px', fontWeight: 800, color: isDark ? '#f1f5f9' : '#0d1b3e' }}>
                    {tableData.length} <span style={{ fontSize: '13px', fontWeight: 500, color: isDark ? '#6b7280' : '#94a3b8' }}>rows</span>
                  </p>
                </div>
              </div>

              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: "'DM Sans',sans-serif" }}>
                  <thead>
                    <tr style={{ backgroundColor: isDark ? '#151827' : '#f8fafc' }}>
                      {['LEADS / TURN', 'SALES', 'CHANNEL', 'DEVELOPER', 'PROJECT', 'STATUS', 'ACTIONS'].map((h) => (
                        <th key={h} style={{ padding: '11px 16px', fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', color: isDark ? '#6b7280' : '#94a3b8', textAlign: 'left', whiteSpace: 'nowrap', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}` }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.length === 0 ? (
                      <tr><td colSpan={7} style={{ padding: '40px', textAlign: 'center', fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8' }}>No entries yet. Add from the form.</td></tr>
                    ) : tableData.map((row, i) => (
                      <tr key={i}
                        style={{ backgroundColor: editingIndex === i ? (isDark ? 'rgba(37,99,235,0.08)' : 'rgba(37,99,235,0.04)') : 'transparent', transition: 'background 0.15s' }}
                        onMouseEnter={(e) => { if (editingIndex !== i) e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)'; }}
                        onMouseLeave={(e) => { if (editingIndex !== i) e.currentTarget.style.backgroundColor = 'transparent'; }}>
                        <td style={{ ...tdBase, fontWeight: 700, color: isDark ? '#93c5fd' : '#1d4ed8' }}>
                          <CellBadge text={`${row.leadsPerTurn} leads`} isDark={isDark}><span>{row.leadsPerTurn} leads</span></CellBadge>
                        </td>
                        <td style={{ ...tdBase, maxWidth: 140 }}>
                          <CellBadge text={row.sales} isDark={isDark}>
                            <span style={{ fontSize: '12px', color: isDark ? '#e5e7eb' : '#374151', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 130, cursor: 'default' }}>{row.sales || '—'}</span>
                          </CellBadge>
                        </td>
                        <td style={{ ...tdBase, maxWidth: 120 }}>
                          <CellBadge text={row.channel} isDark={isDark}>
                            <span style={{ fontSize: '12px', color: isDark ? '#e5e7eb' : '#374151', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 110, cursor: 'default' }}>{row.channel || '—'}</span>
                          </CellBadge>
                        </td>
                        <td style={{ ...tdBase, maxWidth: 140 }}>
                          <CellBadge text={row.project ? row.project.split(', ').map((p) => { const proj = allProjects.find((pr) => pr.name === p); return proj?.developer?.name; }).filter(Boolean).join(', ') : '—'} isDark={isDark}>
                            <span style={{ fontSize: '12px', color: isDark ? '#e5e7eb' : '#374151', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 130, cursor: 'default' }}>
                              {row.project ? row.project.split(', ').map((p) => { const proj = allProjects.find((pr) => pr.name === p); return proj?.developer?.name; }).filter(Boolean).join(', ') || '—' : '—'}
                            </span>
                          </CellBadge>
                        </td>
                        <td style={{ ...tdBase, maxWidth: 140 }}>
                          <CellBadge text={row.project} isDark={isDark}>
                            <span style={{ fontSize: '12px', color: isDark ? '#e5e7eb' : '#374151', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 130, cursor: 'default' }}>{row.project || '—'}</span>
                          </CellBadge>
                        </td>
                        <td style={tdBase}>
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 9px', borderRadius: '20px', fontSize: '11px', fontWeight: 600, backgroundColor: row.active === 'Active' ? (isDark ? 'rgba(74,222,128,0.12)' : 'rgba(22,163,74,0.08)') : (isDark ? 'rgba(248,113,113,0.12)' : 'rgba(239,68,68,0.08)'), color: row.active === 'Active' ? (isDark ? '#4ade80' : '#16a34a') : (isDark ? '#f87171' : '#ef4444'), border: `1px solid ${row.active === 'Active' ? (isDark ? 'rgba(74,222,128,0.25)' : 'rgba(22,163,74,0.2)') : (isDark ? 'rgba(248,113,113,0.25)' : 'rgba(239,68,68,0.2)')}` }}>
                            <span style={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: 'currentColor' }} />
                            {row.active}
                          </span>
                        </td>
                        <td style={tdBase}>
                          <div style={{ display: 'flex', gap: 6 }}>
                            {actionBtn(isDark ? '#93c5fd' : '#1d4ed8', isDark ? 'rgba(37,99,235,0.1)' : 'rgba(37,99,235,0.06)', () => handleUpdateRow(i), <><IconEdit /><span>Edit</span></>, 'Edit row')}
                            {actionBtn(isDark ? '#f87171' : '#ef4444', isDark ? 'rgba(239,68,68,0.1)' : 'rgba(239,68,68,0.06)', () => handleDeleteRow(i), <><IconDelete /><span>Delete</span></>, 'Delete row')}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Save All */}
            {tableData.length > 0 && (
              <button onClick={saveRotation} disabled={loading} type="button"
                style={{ width: '100%', padding: '14px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg,#0D47A1,#0D47A1)', color: '#fff', fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(13,71,161,0.3)', fontFamily: "'DM Sans',sans-serif" }}
                onMouseEnter={(e) => { if (!loading) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(13,71,161,0.4)'; } }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(13,71,161,0.3)'; }}>
                {loading
                  ? <><CircularProgress size={15} style={{ color: '#fff' }} /><span>Saving…</span></>
                  : <><IconSave /><span>Save Changes ({tableData.length} rows)</span></>}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
